export interface UTMParameters {
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  referrerUrl: string | null;
}

export const getUTMS = async () => {
  try {
    const res = await fetch('/get-utm-data/');
    return await res.json();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Fetch utm data error', error);
    return null;
  }
};

const populateRequest = (sendData: boolean) => {
  const keys = ['utm_source', 'utm_medium', 'utm_campaign'];
  const urlParams = new URLSearchParams(window.location.search);
  const formData = new FormData();

  if (sendData) {
    keys.forEach((key) => {
      const value = urlParams.get(key);
      if (value) {
        formData.append(key, value);
      }
    });

    formData.append('referralUrl', document.referrer);
  }

  const param = document.querySelector('span[data-blitz-property="param"]');
  const token = document.querySelector('span[data-blitz-property="token"]');
  if (param && param.textContent && token && token.textContent) {
    formData.append(param.textContent.trim(), token.textContent.trim());
  }
  return formData;
};

const pushData = (formData: FormData, action: string) => {
  fetch(action, {
    method: 'POST',
    body: formData,
  })
    .then((res) => res.json())
    .then(() => {
      const forms = document.querySelectorAll('.utm-loader');
      if (forms.length > 0) {
        window.dispatchEvent(new CustomEvent('utmDataStored'));
      }
    })
    // eslint-disable-next-line no-console
    .catch((err) => console.error('Could not store cookie:', err));
};

export const setUtmCookie = (sendData: boolean) => {
  const formData = populateRequest(sendData);
  pushData(formData, '/set-utm-cookie/');
};

export const setUtmSession = (sendData: boolean) => {
  const formData = populateRequest(sendData);
  pushData(formData, '/set-utm-session/');
};
